// import logo from "./logo.svg";
// import Button from "react-bootstrap/Button";
import React, { useEffect, useState } from "react";

import "../../App.css";
import axios from "axios";
import { useTranslation } from "react-i18next";
import MokUpSlide from "../../MokUpSlide";
import { Fade, Zoom } from "react-awesome-reveal";
import i18next from "i18next";
import { useForm } from "react-hook-form";

// images
import functionIcon01 from "../../img/function_icon_01.png";
import functionIcon02 from "../../img/function_icon_02.png";
import functionIcon03 from "../../img/function_icon_03.png";
import treatmentIcon01 from "../../img/regen_icon_01.png";
import treatmentIcon02 from "../../img/regen_icon_02.png";
import treatmentIcon03 from "../../img/regen_icon_03.png";
import cvpr2022Logo from "../../img/cvpr2022.png";
import cvpr2022ArticleThumbnail from "../../img/cvpr_article_img.jpg";
import aidRegenIcon from "../../img/aid-regen-squircle.png";
import prCenterImg01 from "../../img/prCenterImg01.png";
import prCenterImg02 from "../../img/prCenterImg02.png";
import prCenterImg03 from "../../img/prCenterImg03.png";
import symbolRokit from "../../img/symbol_rokit.png";
import partnersWfu from "../../img/partners/wfu.jpg";
import partnersMgh from "../../img/partners/mgh.jpg";
import partnersAnkara from "../../img/partners/ankara.jpg";
import partnersGuro from "../../img/partners/guro.jpg";
import partnersEunpyeong from "../../img/partners/eunpyeong.jpg";
import partnersQassimi from "../../img/partners/qassimi.png";
import partnersAssiut from "../../img/partners/assiut.png";
import appstoreIcon from "../../img/appstore_icon.svg";

const Main = () => {
  useEffect(() => {
    window.location.replace(
      "https://sites.google.com/rokit.co.kr/aidregen/release-note?authuser=0"
    );
  }, []);

  const { t } = useTranslation();

  const clickHandler = (lang) => {
    i18next.changeLanguage(lang);
    setTextMsg(t("contactLabelMessageDefault"));
  };

  const [isActive, setActive] = useState("false");
  const [textMsg, setTextMsg] = useState(t("contactLabelMessageDefault"));

  const privacyPolicyToggle = () => {
    setActive(!isActive);
  };

  // const { register, handleSubmit } = useForm();
  const [data, setData] = useState("");

  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = async (data) => {
    // 기본으로 data 가져오기
    // console.log(data);

    // const contactCheckbox = document.querySelector("#contactCheckbox:checked");

    // if (contactCheckbox != null) {
    const contactForm = document.querySelector("#contactForm");
    let languageDetect =
      document.querySelector("#contact-us h1").textContent === "Contact Us";
    let contactName = document.querySelector("#contactName").value;
    let contactEmail = document.querySelector("#contactEmail").value;
    // const emaillErrorMessage = document.querySelector(".emaillError");
    let contactOrganization = document.querySelector(
      "#contactOrganization"
    ).value;
    let contactPosition = document.querySelector("#contactPosition").value;
    let contactMessage = document.querySelector("#contactMessage").value;

    //email validation
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    if (!pattern.test(contactEmail)) {
      document.getElementById("contactEmail").focus();
      // emaillErrorMessage.style.display="block";
      return null;
    }
    // else {
    //   emaillErrorMessage.style.display="none";
    // }

    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    const SLACK_WEBHOOK_URL =
      "https://hooks.slack.com/services/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";

    try {
      await axios({
        method: "post",
        url: SLACK_WEBHOOK_URL,
        data: {
          text:
            "[홈페이지 AiD Regen 체험 요청]" +
            "\n" +
            "성함 : " +
            contactName +
            "\n" +
            "이메일 : " +
            contactEmail +
            "\n" +
            "소속 : " +
            contactOrganization +
            "\n" +
            "직급 : " +
            contactPosition +
            "\n" +
            "메시지 내용" +
            "\n" +
            contactMessage +
            "<@aid.regen>",
        },
        headers: headers,
      });
    } catch (err) {
      console.warn(err);
    }
    if (languageDetect === true) {
      contactForm.innerHTML =
        '<h5 style="text-align:center;">Request message sent successfully.</h5>';
    } else {
      contactForm.innerHTML =
        '<h5 style="text-align:center;">요청이 발송되었습니다. 감사합니다.</h5>';
    }
    // }
  };

  const handleTextareaChange = (e) => {
    // setTextMsg(t("contactLabelMessageDefault"))
    setTextMsg(e.target.value);
  };

  // console.log(watch("example")); // watch input value by passing the name of it

  return (
    <div>
      <header className="fixed-top">
        <div className="header-language-btn m-4">
          <button
            className="btn btn-light mx-2 shadow"
            onClick={() => clickHandler("en")}
          >
            🇺🇸 ENG
          </button>
          <button
            className="btn btn-light shadow"
            onClick={() => clickHandler("ko")}
          >
            🇰🇷 KOR
          </button>
        </div>
      </header>
      <main className="flex-shrink-0">
        <header className="bg-aid py-5 position-relative">
          <div className="container p-5">
            <div className="row gx-5 py-xl-5 my-0 my-xl-5 flex-column-reverse flex-xl-row align-items-center justify-content-center">
              <div className="col-lg-8 col-xl-7 col-xxl-6">
                <div className="my-5 text-center text-xl-start">
                  <Fade triggerOnce={true} direction={"up"} duration={700}>
                    <h1
                      className="display-5 fw-bold text-dark mb-2 global"
                      dangerouslySetInnerHTML={{
                        __html: t("splashMainText"),
                      }}
                    />
                  </Fade>
                  <Fade
                    triggerOnce={true}
                    direction={"up"}
                    delay={700}
                    duration={700}
                  >
                    <p
                      className="lead fw-bolder text-dark-50 mb-4"
                      dangerouslySetInnerHTML={{ __html: t("splashSubText") }}
                    />
                  </Fade>

                  <div className="gap-3 d-sm-flex-column justify-content-sm-center justify-content-xl-start">
                    <Fade
                      triggerOnce={true}
                      direction={"up"}
                      delay={1400}
                      duration={700}
                    >
                      <div className="row row-cols-1 row-cols-xl-2 row-cols-sm-1">
                        <div className="col-xl-3 col btn-margin-top ">
                          <a className="text-underline" href="#scroll-target">
                            {t("splashBtnlearnMore")}
                          </a>
                        </div>
                        <div className="col btn-margin-top">
                          <a className="text-underline" href="#contact-us">
                            {t("splashAgetStarted")}
                          </a>
                        </div>
                      </div>
                    </Fade>

                    <Fade
                      triggerOnce={true}
                      direction={"up"}
                      delay={2100}
                      duration={700}
                    >
                      <div className="btn-appstore">
                        <a
                          href="https://apps.apple.com/us/app/aidregen/id6444200739"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            className="img-fluid mb-5 mb-lg-0"
                            src={appstoreIcon}
                            alt="..."
                          />
                        </a>
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
              <div className="col-xl-5 col-xxl-5 d-block text-center">
                <Fade triggerOnce={true} direction={"right"} duration={1000}>
                  <MokUpSlide />
                </Fade>
              </div>
            </div>
          </div>
        </header>
        {/* <!-- About section one--> */}
        <section className="py-5" id="scroll-target">
          <div className="container pt-5 px-5 mt-5">
            <div className="row gx-5 justify-content-center mb-5">
              <div className="col-lg-8 col-xl-6">
                <Fade
                  triggerOnce={true}
                  direction={"up"}
                  delay={300}
                  duration={700}
                >
                  <div className="text-center">
                    <h1 className="fw-bolder">{t("whatCanDoMainText")}</h1>
                  </div>
                </Fade>
              </div>
            </div>
            <Fade
              triggerOnce={true}
              direction={"right"}
              delay={300}
              duration={700}
            >
              <div className="row pt-5 gx-5 align-items-center justify-content-center">
                <div className="col-lg-3">
                  <img
                    className="img-fluid mb-5 mb-lg-0"
                    src={functionIcon01}
                    alt="..."
                  />
                </div>
                <div className="col-lg-6">
                  <h2 className="fw-bolder mb-3">Scan & 3D Modeling</h2>
                  <p
                    className="lead fw-normal text-muted mb-0"
                    dangerouslySetInnerHTML={{ __html: t("whatCanDoStep01") }}
                  />
                </div>
              </div>
            </Fade>
          </div>
        </section>
        {/* <!-- About section two--> */}
        <section className="py-5">
          <div className="container px-5 my-0">
            <Fade
              triggerOnce={true}
              direction={"left"}
              delay={300}
              duration={700}
            >
              <div className="row gx-5 align-items-center justify-content-center">
                <div className="col-lg-3 order-first order-lg-last">
                  <img
                    className="img-fluid mb-5 mb-lg-0"
                    src={functionIcon02}
                    alt="..."
                  />
                </div>
                <div className="col-lg-6">
                  <h2 className="fw-bolder mb-3">Optimization</h2>
                  <p
                    className="lead fw-normal text-muted mb-0"
                    dangerouslySetInnerHTML={{ __html: t("whatCanDoStep02") }}
                  />
                </div>
              </div>
            </Fade>
          </div>
        </section>
        {/* <!-- About section three--> */}
        <section className="py-5" id="">
          <div className="container px-5 mb-5 pb-5">
            <Fade
              triggerOnce={true}
              direction={"right"}
              delay={300}
              duration={700}
            >
              <div className="row gx-5 align-items-center justify-content-center">
                <div className="col-lg-3">
                  <img
                    className="img-fluid mb-5 mb-lg-0"
                    src={functionIcon03}
                    alt="..."
                  />
                </div>
                <div className="col-lg-6">
                  <h2 className="fw-bolder mb-3">Regeneration</h2>
                  <p
                    className="lead fw-normal text-muted mb-0"
                    dangerouslySetInnerHTML={{ __html: t("whatCanDoStep03") }}
                  />
                </div>
              </div>
            </Fade>
          </div>
        </section>
        {/* <!-- Team members section--> */}
        <section className="py-5 bg-light">
          <div className="container px-5 my-5">
            <div className="row gx-5 justify-content-center mb-5">
              <div className="col-lg-8 col-xl-6">
                <Fade
                  triggerOnce={true}
                  direction={"up"}
                  delay={300}
                  duration={700}
                >
                  <div className="text-center">
                    <h1 className="fw-bolder">{t("whatCanBeMainText")}</h1>
                  </div>
                </Fade>
              </div>
            </div>
            <div className="row gx-5 row-cols-1 row-cols-sm-2 row-cols-xl-4 justify-content-center">
              <div className="col mb-5 mb-5 mb-xl-0">
                <Fade triggerOnce={true} direction={"up"} duration={700}>
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <img
                      className="img-fluid mb-4"
                      src={treatmentIcon01}
                      alt="..."
                    />
                    <h3 className="fw-bolder mb-3">Cartilage Regen</h3>
                    <ul style={{ marginRight: 30 }}>
                      <li>Osteoarthiritis</li>
                    </ul>
                  </div>
                </Fade>
              </div>
              <div className="col mb-5 mb-5 mb-xl-0">
                <Fade triggerOnce={true} direction={"up"} duration={700}>
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <img
                      className="img-fluid mb-4"
                      src={treatmentIcon02}
                      alt="..."
                    />
                    <h3 className="fw-bolder mb-3">Skin Regen</h3>
                    <ul style={{ marginRight: 30 }}>
                      <li>Diabetic Foot Ulcer</li>
                      <li>Burn</li>
                      <li>Skin Cancer</li>
                      <li>Bedsore</li>
                    </ul>
                  </div>
                </Fade>
              </div>
              <div className="col mb-5 mb-5 mb-sm-0">
                <Fade triggerOnce={true} direction={"up"} duration={700}>
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <img
                      className="img-fluid mb-4"
                      src={treatmentIcon03}
                      alt="..."
                    />
                    <h3 className="fw-bolder mb-3">Kidney Regen</h3>
                    <ul style={{ marginRight: 30 }}>
                      <li>Renal Failure</li>
                    </ul>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- Team members section--> */}
        <section className="py-5">
          <div className="container px-5 my-5">
            <div className="row gx-5 justify-content-center mb-5">
              <div className="col-lg-8 col-xl-6">
                <Fade
                  triggerOnce={true}
                  direction={"up"}
                  delay={300}
                  duration={700}
                >
                  <div className="text-center">
                    <h1 className="fw-bolder">Accepted to CVPR 2022</h1>
                  </div>
                </Fade>
              </div>
            </div>
            <Fade
              triggerOnce={true}
              direction={"up"}
              delay={700}
              duration={700}
            >
              <div className="row gx-5 row-cols-1 row-cols-sm-1 row-cols-xl-2 justify-content-center">
                <div className="col d-flex flex-column justify-content-center align-items-center mb-5 mb-5 pt-5 pb-3 px-5 mb-xl-0 shadow border-Radius-Rounded">
                  <div className="d-flex flex-column flex-xl-row justify-content-center align-items-center">
                    <div className="">
                      <h3 className="fw-bolder mb-3">
                        ROKIT Healthcare’s Latest Paper About Its AI Technology
                        Has Been Accepted to CVPR 2022
                      </h3>
                      <a
                        href="https://apnews.com/press-release/pr-newswire/science-technology-business-artificial-intelligence-a3b97992db35aa7e0729777e1b361007"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <button className="btn btn-aid btn-lg border-Radius-Rounded px-5 me-sm-3">
                          {t("splashBtnlearnMore")}
                        </button>
                      </a>
                    </div>
                    <img
                      className="img-fluid mt-5 mt-sm-5 mt-xl-0"
                      src={cvpr2022Logo}
                      alt="..."
                    />
                  </div>
                  <img
                    className="img-fluid mt-5 mb-4"
                    src={cvpr2022ArticleThumbnail}
                    alt="..."
                  />
                </div>
              </div>
            </Fade>
          </div>
        </section>
        {/* <!-- Features section--> */}
        <section className="py-5 bg-light" id="product-identity">
          <div className="container px-5 my-5">
            <div className="row gx-5 d-flex align-items-center justify-content-center">
              <div className="mb-4">
                <h1 className="fw-bolder mb-5 text-center">Product Identity</h1>
              </div>
              <div className="col-xl-4 text-center mb-5 mb-xl-0">
                <Zoom triggerOnce={true} delay={300} duration={700}>
                  <img className="img-fluid" src={aidRegenIcon} alt="..." />
                </Zoom>
              </div>
              <div className="col-lg-8 width-fit-content pi-text">
                <div className="row gx-5 row-cols-1 d-flex flex-column width-fit-content">
                  <Fade
                    triggerOnce={true}
                    direction={"up"}
                    delay={1200}
                    duration={700}
                  >
                    <div className="col mb-4 h-100 circle">
                      <h2 className="h5">AI Technology</h2>
                      <p className="mb-0">{t("piText01")}</p>
                    </div>
                  </Fade>
                  <Fade
                    triggerOnce={true}
                    direction={"up"}
                    delay={1700}
                    duration={700}
                  >
                    <div className="col mb-4 circle">
                      <h2 className="h5">Doctor</h2>
                      <p className="mb-0">{t("piText02")}</p>
                    </div>
                  </Fade>
                  <Fade
                    triggerOnce={true}
                    direction={"up"}
                    delay={2200}
                    duration={700}
                  >
                    <div className="col mb-4 mb-md-0 circle">
                      <h2 className="h5">Organ Regeneration</h2>
                      <p className="mb-0">{t("piText03")}</p>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- Team members section--> */}
        <section className="py-5">
          <div className="container px-0 px-xl-5 my-5">
            <div className="row gx-5 justify-content-center mb-5">
              <div className="col-lg-8 col-xl-6">
                <Fade
                  triggerOnce={true}
                  direction={"up"}
                  delay={300}
                  duration={700}
                >
                  <div className="text-center">
                    <h1 className="fw-bolder">PR Center</h1>
                  </div>
                </Fade>
              </div>
            </div>
            <div className=" w-75 mx-auto justify-content-center">
              <Fade
                triggerOnce={true}
                direction={"up"}
                delay={500}
                duration={700}
              >
                <div className="d-flex flex-column justify-content-between mb-5 pt-5 pb-5 px-5 mb-xl-5 shadow border-Radius-Rounded">
                  <h3
                    className="fw-bolder mb-3 word-break-keep-all"
                    dangerouslySetInnerHTML={{
                      __html: t("prCenterArticleHeadline01"),
                    }}
                  />
                  <div className="d-flex justify-content-between align-items-center article-card">
                    <img
                      className="img-fluid mt-3 mt-5 mt-sm-5 mt-xl-0"
                      src={prCenterImg01}
                      alt="..."
                    />
                    <a
                      href="https://www.youtube.com/watch?v=2StEsMSwJq4"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <button className="w-100 btn btn-rokit btn-lg border-Radius-Rounded px-5 mt-4">
                        {t("btnWatchVideo")}
                      </button>
                    </a>
                  </div>
                </div>
              </Fade>
              <Fade
                triggerOnce={true}
                direction={"up"}
                delay={500}
                duration={700}
              >
                <div className="d-flex flex-column justify-content-between mb-5 pt-5 pb-5 px-5 mb-xl-5 shadow border-Radius-Rounded">
                  <h3 className="fw-bolder mb-3 word-break-keep-all">
                    {t("prCenterArticleHeadline02")}
                  </h3>
                  <div className="d-flex justify-content-between align-items-center article-card">
                    <img
                      className="img-fluid mt-3 mt-5 mt-sm-5 mt-xl-0"
                      src={prCenterImg02}
                      alt="..."
                    />
                    <a
                      href="https://www.fnnews.com/news/202105100945063254"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <button className="w-100 btn btn-aid btn-lg border-Radius-Rounded px-5 mt-4">
                        {t("splashBtnlearnMore")}
                      </button>
                    </a>
                  </div>
                </div>
              </Fade>
              <Fade
                triggerOnce={true}
                direction={"up"}
                delay={500}
                duration={700}
              >
                <div className="d-flex flex-column justify-content-between mb-5 pt-5 pb-5 px-5 mb-xl-5 shadow border-Radius-Rounded">
                  <h3 className="fw-bolder mb-3 word-break-keep-all">
                    {t("prCenterArticleHeadline03")}
                  </h3>
                  <div className="d-flex justify-content-between align-items-center article-card">
                    <img
                      className="h-100 img-fluid mt-3 mt-5 mt-sm-5 mt-xl-0"
                      src={prCenterImg03}
                      alt="..."
                    />
                    <a
                      href="https://www.sentv.co.kr/news/view/597326"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <button className="btn btn-aid btn-lg border-Radius-Rounded px-5 mt-4">
                        {t("splashBtnlearnMore")}
                      </button>
                    </a>
                  </div>
                </div>
              </Fade>
            </div>
          </div>
        </section>
        {/* <!-- About section one--> */}
        <section className="py-5 bg-light" id="about-us">
          <div className="container py-5 px-5">
            <div className="row gx-5 justify-content-center mb-5">
              <div className="col-lg-8 col-xl-6">
                <Fade
                  triggerOnce={true}
                  direction={"up"}
                  delay={300}
                  duration={700}
                >
                  <div className="text-center">
                    <h1 className="fw-bolder">About Us</h1>
                  </div>
                </Fade>
              </div>
            </div>
            <div className="row pt-5 gx-5 align-items-center justify-content-center">
              <div className="col-lg-6 mb-5 mb-xl-0">
                <Fade triggerOnce={true} direction={"up"} duration={700}>
                  <h2 className="fw-bolder mb-3">"Aging is Disease."</h2>
                </Fade>
                <Fade
                  triggerOnce={true}
                  direction={"up"}
                  delay={300}
                  duration={700}
                >
                  <p
                    className="lead fw-bolder text-dark-50 mb-4"
                    dangerouslySetInnerHTML={{ __html: t("aboutUsText") }}
                  />
                </Fade>
                <Fade
                  triggerOnce={true}
                  direction={"up"}
                  delay={600}
                  duration={700}
                >
                  <a
                    href="https://rokithealthcare.com/our-story/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <button className="btn btn-aid btn-lg border-Radius-Rounded px-5">
                      {t("splashBtnlearnMore")}
                    </button>
                  </a>
                </Fade>
              </div>
              <div className="col-lg-3">
                <Fade
                  triggerOnce={true}
                  direction={"right"}
                  delay={300}
                  duration={700}
                >
                  <img
                    className="img-fluid p-3 mb-5 mb-lg-0"
                    src={symbolRokit}
                    alt="..."
                  />
                </Fade>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- About section one--> */}
        <section className="py-5" id="partners">
          <div className="container col col-xl-6 py-5">
            <div className="row justify-content-center mb-5">
              <Fade
                triggerOnce={true}
                direction={"up"}
                delay={300}
                duration={700}
              >
                <div className="text-center">
                  <h1 className="fw-bolder">{t("partnersMainText")}</h1>
                </div>
              </Fade>
            </div>
            <div className="d-flex flex-wrap justify-content-center">
              <Fade triggerOnce={true} duration={700}>
                <a
                  className="mb-3"
                  href="https://www.wfu.edu"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img className="" src={partnersWfu} alt="..." />
                </a>
              </Fade>
              <Fade triggerOnce={true} duration={700}>
                <a
                  className="mb-3"
                  href="https://www.massgeneral.org"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img className="" src={partnersMgh} alt="..." />
                </a>
              </Fade>
              <Fade triggerOnce={true} duration={700}>
                <a
                  className="mb-3"
                  href="https://ankarasehir.saglik.gov.tr"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img className="" src={partnersAnkara} alt="..." />
                </a>
              </Fade>
              <Fade triggerOnce={true} duration={700}>
                <a
                  className="mb-3"
                  href="http://guro.kumc.or.kr"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img className="" src={partnersGuro} alt="..." />
                </a>
              </Fade>
              <Fade triggerOnce={true} duration={700}>
                <a
                  className="mb-3"
                  href="https://www.cmcep.or.kr/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img className="" src={partnersEunpyeong} alt="..." />
                </a>
              </Fade>
              <Fade triggerOnce={true} duration={700}>
                <a
                  className="mb-3"
                  href="https://goo.gl/maps/t1EQjzQsc1B4Bq548"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img className="" src={partnersQassimi} alt="..." />
                </a>
              </Fade>
              <Fade triggerOnce={true} duration={700}>
                <a
                  href="https://www.aun.edu.eg/hospitals/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img className="" src={partnersAssiut} alt="..." />
                </a>
              </Fade>
            </div>
          </div>
        </section>
        <section className="py-5 bg-light" id="contact-us">
          <div className="container py-5">
            <div className="row justify-content-center mb-4">
              <Fade
                triggerOnce={true}
                direction={"up"}
                delay={300}
                duration={700}
              >
                <div className="text-center">
                  <h1 className="fw-bolder">{t("contactMainText")}</h1>
                  <p>{t("contactSubText")}</p>
                </div>
              </Fade>
            </div>
            <div className="d-flex flex-wrap justify-content-center">
              <Fade
                className="w-100"
                triggerOnce={true}
                direction={"up"}
                delay={700}
                duration={700}
              >
                <div className="bg-white m-auto col-xl-6 col-10 d-flex justify-content-center align-items-center py-5 px-4 px-xl-5 shadow border-Radius-Rounded">
                  <form
                    className="d-flex flex-column w-100"
                    id="contactForm"
                    // onSubmit={handleSubmit((data) =>
                    //   setData(JSON.stringify(data))
                    // )}

                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <fieldset className="mb-3">
                      <h6>
                        {t("contactLabelName")}
                        <span style={{ color: "#f08000" }}>*</span>
                      </h6>
                      <input
                        className="w-100"
                        id="contactName"
                        {...register("name")}
                        type="text"
                        required
                        placeholder={t("contactLabelNamePlaceholder")}
                      />
                    </fieldset>

                    <fieldset className="mb-3">
                      <h6>
                        {t("contactLabelOrganization")}
                        <span style={{ color: "#f08000" }}>*</span>
                      </h6>
                      <input
                        className="w-100"
                        id="contactOrganization"
                        {...register("organization")}
                        type="text"
                        required
                        placeholder={t("contactLabelOrganizationPlaceholder")}
                      />
                    </fieldset>

                    <fieldset className="mb-3">
                      <h6>
                        {t("contactLabelPosition")}
                        <span style={{ color: "#f08000" }}>*</span>
                      </h6>
                      <input
                        className="w-100"
                        id="contactPosition"
                        {...register("position")}
                        type="text"
                        required
                        placeholder={t("contactLabelPositionPlaceholder")}
                      />
                    </fieldset>

                    <fieldset className="mb-3">
                      <h6>
                        {t("contactLabelEmail")}
                        <span style={{ color: "#f08000" }}>*</span>
                      </h6>
                      <input
                        className="w-100"
                        id="contactEmail"
                        {...register("email")}
                        type="email"
                        required
                        placeholder={t("contactLabelEmailPlaceholder")}
                      />
                      <p
                        className="emaillError"
                        style={{ color: "red", display: "none" }}
                      >
                        이메일 양식을 확인하세요.
                      </p>
                    </fieldset>

                    <fieldset className="mb-3">
                      <h6>
                        {t("contactLabelComments")}
                        <span style={{ color: "#f08000" }}>*</span>
                      </h6>
                      <p style={{ paddingLeft: 4, fontSize: 16 }}>
                        {t("contactLabelMsg")}
                      </p>
                      <textarea
                        className="w-100"
                        id="contactMessage"
                        {...register("message")}
                        type="text"
                        required
                        placeholder={t("contactLabelMessagePlaceholder")}
                        defaultValue={t("contactLabelMessageDefault")}
                        // value = {this.state.value}
                        onChange={handleTextareaChange}
                        // value={t("contactLabelMessageDefault")}
                        value={textMsg}
                      >
                        {/* {t("contactLabelMessageDefault")} */}
                      </textarea>
                    </fieldset>
                    <fieldset className="d-flex flex-column mb-4">
                      {/* <h6>{t("contactLabelPrivacyPolicyCallModalText")}{t("contactLabelPrivacyPolicyTextKo")}</h6> */}
                      <section
                        id="privacyPolicyModal"
                        className="mb-2"
                        // className={isActive ? "d-none" : "d-block"}
                      >
                        <div className="privacy-policy-pop-up">
                          <div
                            className="privacy-policy-pop-up-contents"
                            dangerouslySetInnerHTML={{
                              __html: t("privacyPolicyModalInnerHtml"),
                            }}
                          />
                          {/* <div
                              onClick={privacyPolicyToggle}
                              className="ModalCloseBtn btn btn-aid btn-lg border-Radius-Rounded px-5"
                              style={{marginTop: -15,}}
                            >
                              {t("privacyPolicyModalCloseBtn")}
                            </div> */}
                        </div>
                      </section>
                      <div className="d-flex flex-row justify-content-center align-items-center">
                        <input
                          style={{
                            marginRight: 5,
                          }}
                          id="contactCheckbox"
                          type="checkbox"
                          required
                        />
                        <div className="mb-0">
                          {t("contactLabelPrivacyPolicyTextEn")}
                          <span
                            style={
                              {
                                // color: "#f08000",
                                // fontWeight: "600",
                                // cursor: "pointer",
                                // textDecoration: "underline",
                              }
                            }
                            // onClick={privacyPolicyToggle}
                          >
                            {t("contactLabelPrivacyPolicyCallModalText")}
                          </span>
                          {t("contactLabelPrivacyPolicyTextKo")}
                          <span style={{ color: "#f08000" }}>*</span>
                        </div>
                      </div>
                    </fieldset>
                    <input
                      value={t("contactSubmitButton")}
                      type="submit"
                      // onClick={sendSlackMessage}
                    />
                  </form>
                  {/* <div className="lead w-100" dangerouslySetInnerHTML={
                        {__html: t('registerHtml')}
                      } /> */}
                </div>
              </Fade>
              {/* <div dangerouslySetInnerHTML={
                        {__html: t('registerScript')}
                      } /> */}
            </div>
          </div>
        </section>
      </main>
      {/* <footer className="bg-aid-footer py-4 mt-auto">
        <div className="">
          <div className="">
            <div className="col-auto">
              <div className="small mt-2 text-white text-center footer-font">
                <p className="mb-3">
                  12F, 9, Digital-ro 10-gil, Geumcheon-gu (High-Hill Bldg,
                  Gasan-dong), Seoul, Republic of Korea, 08514, COMPANY :{" "}
                  <a
                    href="https://rokithealthcare.com"
                    style={{ color: "white" }}
                  >
                    ROKIT Healthcare
                  </a>
                  , COMPANY # : 119-86-51995, CEO : Seok Hwan You
                </p>
                <p>
                  Copyright ©{" "}
                  <a
                    href="https://rokithealthcare.com"
                    style={{ color: "white" }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    ROKIT HEALTHCARE
                  </a>
                  , INC. All Rights Reserved &nbsp;&nbsp;&nbsp;
                  <a
                    href="https://sites.google.com/rokit.co.kr/aidregen/privacy-policy"
                    style={{ color: "white" }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Privacy policy
                  </a>
                  &nbsp;&nbsp;&nbsp; |&nbsp;&nbsp;&nbsp;
                  <a
                    href="https://sites.google.com/rokit.co.kr/aidregen/terms-of-services"
                    style={{ color: "white" }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Terms of services
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer> */}
    </div>
  );
};
export default Main;
